import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Provider, ErrorBoundary } from '@rollbar/react'; // Provider imports 'rollbar'
import App from './App';
import {onLCP, onINP, onCLS} from 'web-vitals';

onCLS(console.log);
onINP(console.log);
onLCP(console.log);

const APP_ENVIRONMENT = window._env_.REACT_APP_ENVIRONMENT || "undefined";
const ROLLBAR_BLACKLIST = ['local', 'esther', 'magnus'];

const ROLLBAR_CONFIG = !ROLLBAR_BLACKLIST.includes(APP_ENVIRONMENT) ? {
    accessToken: 'c0e72d2aae2a40488edc60ba2445cc71',
    environment: APP_ENVIRONMENT || "undefined",
    captureUncaught: true,
    captureUnhandledRejections: true,
} : { enabled: false }

// Provider instantiates Rollbar client instance handling any uncaught errors or unhandled promises in the browser
// ErrorBoundary catches all React errors in the tree below and logs them to Rollbar

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider config={ROLLBAR_CONFIG}>
        <ErrorBoundary>
            <App />
        </ErrorBoundary>
    </Provider>
);
